import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Label, FormFeedback } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

class EnviarMailUVT extends Component {
    constructor(props) {
        super(props);
        this.state = {
            empresa: null,
            canal: null,
            ltp: null,
            lte: null,
            datos: [],
            newEmail: ""
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    resetState() {
        this.setState({
            empresa: null,
            canal: null,
            ltp: null,
            lte: null,
            emails: [],
            newEmail: ""
        })
    }
    setSelects(data) {
        this.setState({
            solicitud: data.pk,
            proyecto_codigo: data.codigo,
            empresa_id: data.empresa_id,
            ltp_id: data.ltp_id,
            uvt_id: data.presupuesto.uvt_id,
        });
    }

    handleClick(i) {
        var emails = this.state.emails;
        emails[i].checked = !emails[i].checked;
        this.setState({ emails: emails });
    }

    AddNewMail(e) {
        e.preventDefault();
        if (this.state.newEmail != "") {
            var emails = this.state.emails;
            emails.push({
                razon: "--",
                email: this.state.newEmail,
                checked: true,
            });
            this.setState({ emails: emails, newEmail: "" });
        }
    }

    render() {
        var atr = [];
        if (this.state.emails) {
            for (var i = 0; i < this.state.emails.length; i++) {
                let p = i;
                let rowN = i.toString();
                let row = this.state.emails[i];
                atr.push(
                    <tr key={p}>
                        <td>
                            <input readOnly={true} onClick={(value) => this.handleClick(p)} type={"checkbox"} checked={row.checked} />
                        </td>
                        <td>
                            {row.razon}
                        </td>
                        <td>
                            <input readOnly={true} className={"d-none"} disabled={!row.checked} name={"email[" + p + "]"} value={row.email} />
                            {row.email}
                        </td>
                    </tr>
                );
            }
        }

        return (
            <ParadigmaModal
                getUrl={api.proyectos.enviodemails.enviarmailuvt}
                postUrl={api.proyectos.enviodemails.enviarmailuvt}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Mail ha sido enviado a la UVT con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Solicitar Factura"}
                buttonTitle={"Solicitar Factura"}
                buttonIcon={"fa fa-file fa-lg"}
                notAllowedMessage={"La Informe no puede ser enviado porque todavía no se completaron todos los datos necesarios."}

                saveButton={true}
                saveButtonLabel={"Enviar"}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetState()}
                className={"ui-modal-dialog ui-modal-lg"}
            >
                <div className="ui-form">
                    <div className="ui-section-grid">
                        <section className="ui-section-block ui-section-span-2">
                            <p className="ui-section-label">Datos del informe</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Código</Label>
                                    <ParadigmaAsyncSeeker pkField={"codigo"} nombreField={"cod"} fieldName={""} url={api.proyectos.solicitudes.selectcodigo} value={this.state.proyecto_codigo} disabled={true} />
                                    <FormFeedback />
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Proyecto</Label>
                                    <ParadigmaAsyncSeeker fieldName={"solicitud_id"} url={api.proyectos.solicitudes.select} value={this.state.solicitud} disabled={true} />
                                    <FormFeedback />
                                </div>
                            </div>
                        </section>

                        <section className="ui-section-block ui-section-span-2">
                            <p className="ui-section-label">Facturación</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Empresa</Label>
                                    <ParadigmaAsyncSeeker url={api.clientes.empresas.select}
                                        value={this.state.empresa_id} disabled={true} />
                                    <FormFeedback />
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>UVT</Label>
                                    <ParadigmaAsyncSeeker url={api.proyectos.config.presupuesto.uvt.select}
                                        value={this.state.uvt_id} disabled={true} />
                                    <FormFeedback />
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>LTP</Label>
                                    <ParadigmaAsyncSeeker url={api.usuarios.usuarios.select} value={this.state.ltp_id}
                                        disabled={true} />
                                    <FormFeedback />
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </ParadigmaModal>
        );
    }
}

export default EnviarMailUVT;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento6/EnviarMailUVT.js